import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Ravi Kumar",
    role: "Owner, Kumar Traders",
    city: "Tumakuru",
    text: "NP Associates has handled our GST returns for over 3 years now. Zero late fees, zero stress. Highly recommended for any small business owner in Tumakuru.",
    rating: 5,
  },
  {
    name: "Priya Sharma",
    role: "Freelance Designer",
    city: "Bengaluru",
    text: "As a freelancer, I was terrified of tax filings. NP Associates made ITR filing painless and saved me money in deductions I didn't even know I qualified for.",
    rating: 5,
  },
  {
    name: "Anil Gowda",
    role: "Director, Gowda Textiles Pvt Ltd",
    city: "Tumakuru",
    text: "From company registration to monthly compliance, they've been our end-to-end financial partner. Genuinely affordable and always responsive.",
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="relative border-b border-border bg-background py-24 md:py-32"
      data-testid="testimonials-section"
    >
      <div className="container mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="mb-4 flex items-center gap-3">
              <span className="h-px w-10 bg-primary" />
              <span className="font-[Outfit] text-xs font-bold uppercase tracking-[0.2em] text-primary">
                Client Voices
              </span>
            </div>
            <h2 className="text-4xl font-extrabold leading-tight tracking-tight text-foreground md:text-5xl">
              Trusted by businesses<br />
              <span className="italic text-primary">across Karnataka.</span>
            </h2>
            <div className="mt-8 overflow-hidden border border-border">
              <img
                src="https://images.pexels.com/photos/36712839/pexels-photo-36712839.jpeg"
                alt="Client partnership"
                className="h-64 w-full object-cover"
                loading="lazy"
                data-testid="testimonials-image"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6 md:col-span-7">
            {testimonials.map((t, i) => (
              <motion.article
                key={t.name}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="relative border border-border bg-white p-8"
                data-testid={`testimonial-${i}`}
              >
                <Quote className="absolute -top-3 left-6 h-6 w-6 bg-white px-1 text-primary" />
                <div className="flex items-center gap-1">
                  {Array.from({ length: t.rating }).map((_, k) => (
                    <Star key={k} className="h-4 w-4 fill-primary text-primary" />
                  ))}
                </div>
                <p className="mt-4 text-base leading-relaxed text-foreground">
                  &ldquo;{t.text}&rdquo;
                </p>
                <div className="mt-6 flex items-center justify-between border-t border-border pt-4">
                  <div>
                    <div className="font-[Outfit] text-sm font-bold text-foreground">
                      {t.name}
                    </div>
                    <div className="text-xs text-muted-foreground">{t.role}</div>
                  </div>
                  <span className="font-[Outfit] text-[10px] font-bold uppercase tracking-widest text-primary">
                    {t.city}
                  </span>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
